import { StorylineTableType } from '@/types/cms/Storylines'
import { toKebabCase } from '@/utils/string'
import styles from './StorylineTable.module.scss'

export default function StorylineTable({ item }: Readonly<{ item: { model: StorylineTableType } }>) {
  const model = item.model
  const isVerticalTable = model.fields?.rowheader?.value === 'true'
  const isHorizontalTable = model.fields?.columnheader?.value === 'true'

  let tableData: Array<Array<string>>

  try {
    // Sanitize the JSON string by replacing unescaped newlines and other control characters
    const sanitizedValue = model.fields.tableeditor.value
      .replace(/\r\n/g, '\\n') // Replace Windows line endings
      .replace(/\n/g, '\\n') // Replace Unix line endings
      .replace(/\r/g, '\\n') // Replace Mac line endings
      .replace(/\t/g, '\\t') // Replace tabs

    tableData = JSON.parse(sanitizedValue)
  } catch (error) {
    console.error('Failed to parse table data:', error)
    return (
      <div className={styles.table}>
        <p>Error: Unable to display table data</p>
      </div>
    )
  }

  return (
    <table className={styles.table}>
      <tbody>
        {tableData.map((item, index) => {
          const keyNameToKebab = `${item[0]}`
          const generatedKey = toKebabCase(keyNameToKebab) + index
          return (
            <tr key={generatedKey}>
              {item.map((e, i) => {
                const keyNameToKebab = `${e}`
                const generatedKey2 = toKebabCase(keyNameToKebab) + index
                if (!isVerticalTable) {
                  if (!isHorizontalTable) return <td key={generatedKey2}>{e}</td>
                  if (i === 0) return <th key={generatedKey2}>{e}</th>
                  return <td key={generatedKey2}>{e}</td>
                }
                if (isVerticalTable) {
                  if (index === 0) return <th key={generatedKey2}>{e}</th>
                  return <td key={generatedKey2}>{e}</td>
                }
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
